export function getdata() {
	var obj = {
		searchlist: [{
				prop: "shuiybh",
				label: '税源编号',
				type: "input"
			},
			{
				prop: "paifkmc",
				label: '排放口名称',
				type: "input"
			},


		],
		searchdata: {
			shuiybh: "",
			paifkmc: "",
		},
		yuefdata: [{
			label: "1月",
			value: "1",
		}, {
			label: "2月",
			value: "2",
		}, {
			label: "3月",
			value: "3",
		}, {
			label: "4月",
			value: "4",
		}, {
			label: "5月",
			value: "5",
		}, {
			label: "6月",
			value: "6",
		}, {
			label: "7月",
			value: "7",
		}, {
			label: "8月",
			value: "8",
		}, {
			label: "9月",
			value: "9",
		}, {
			label: "10月",
			value: "10",
		}, {
			label: "11月",
			value: "11",
		}, {
			label: "12月",
			value: "12",
		}],
		headData: [{
				title: "选择",
				prop: "id",
				width: "100",
				custom: true
			},
			{
				title: "序号",
				prop: "xh",
				width: "100",
				custom: true
			},
			{
				title: "税源编号",
				prop: "shuiybh",
				width: "200"
			},
			{
				title: "排放口名称或噪声源名称",
				prop: "paifkmc",
				width: "200"
			},
			{
				title: "污染物类别",
				prop: "wurwlb",
				width: "200",
				custom: true
			},
			{
				title: "税源有效期起",
				prop: "youxqq",
				width: "200",
			},
			{
				title: "税源有效期止",
				prop: "youxqz",
				width: "200",
			},
			{
				title: "水污染种类",
				prop: "shuiwrwzl",
				width: "200",
				custom: true
			},
			{
				title: "污染物名称（代码）",
				prop: "wurwmc",
				width: "200"
			},
			{
				title: "征收子目（代码）",
				prop: "zhengszm",
				width: "200"
			},
			{
				title: "污染物排放量计算方法",
				prop: "wurwpfljsff",
				width: "200",
				custom: true
			},
			{
				title: "执行标准（编码）",
				prop: "zhixbz",
				width: "200"
			},
			{
				title: "标准浓度值（毫克/升、毫克/标立方米）",
				prop: "biaozndz",
				width: "250"
			},
			{
				title: "计税基数单位",
				prop: "jisjsdw",
				width: "200"
			},
			{
				title: "污染物单位",
				prop: "wurwdw",
				width: "200"
			},
			{
				title: "产污系数",
				prop: "chanwxs",
				width: "200"
			},
			{
				title: "排污系数",
				prop: "paiwxs",
				width: "200"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
